import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../../../common/back-link';
import PageTitle from '../../../../common/page-title';
import { getScan } from '../../../../../actions/scans';
import DamagedBarcodeSubmissionViewDetails from './damaged-barcode-submission-view-details';

class DamagedBarcodeSubmissionViewPage extends Component {
  componentDidMount() {
    const { match: { params: { id } }, dispatch } = this.props;

    dispatch(getScan(id));
  }

  render() {
    const { loading, scannerCode } = this.props;

    return (
      <div className="container-fluid">
        <Row>
          <Col>
            <BackLink href="/admin/scans/damaged-barcode-submissions" />
          </Col>
          <PageTitle>View/Edit Damaged Barcode Submission</PageTitle>
          {loading ? 'Loading...' : scannerCode.attributes && <DamagedBarcodeSubmissionViewDetails scannerCode={scannerCode} />}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: !state.scans.fetched && state.scans.fetching,
  scannerCode: state.scans.scannerCode
});

export default connect(mapStateToProps)(DamagedBarcodeSubmissionViewPage);
